import {
  START_CREATE_LEARNING_ROUTE,
  START_GET_LEARNING_ROUTE,
  START_EDIT_LEARNING_ROUTE,
  START_DELETE_LEARNING_ROUTE,
  START_GET_LEARNING_ROUTE_BY_ID,
} from "../types";

export const createLearningRoute = (name, description, courseIds, level, order = 0, status = true) => {
  return {
    type: START_CREATE_LEARNING_ROUTE,
    payload: { name, description, courseIds, level, order, status }
  };
};

export const editLearningRoute = (id, name, description, courseIds, level, order, status) => {
  return {
    type: START_EDIT_LEARNING_ROUTE,
    payload: { id, name, description, courseIds, level, order, status },
  };
};


export const getLearningRoutes = () => {
  return {
    type: START_GET_LEARNING_ROUTE
  };
};

export const deleteLearningRoute = (id) => ({
  type: START_DELETE_LEARNING_ROUTE,
  payload: id,
});


export const getLearningRouteById = (id) => ({
  type: START_GET_LEARNING_ROUTE_BY_ID,
  payload: id,
});
